import React from 'react'
import { Layout, SEO } from '../components'

export default function () {
  const title = `Contact`
  const description = 'this page description'
  return (
    <Layout>
      <SEO title={title} description={description} />
      <h1>I'd love to talk! Email me at the address below</h1>
      <p>
        <a href="mailto:jxjwilliam@gmail.com">jxjwilliam@gmail.com</a>
      </p>
    </Layout>
  )
}
